<template>
  <v-layout wrap v-if="content">
    <v-flex xs12 style="padding: 10px 0 20px 0;">
      <v-text-field
        v-model="content.MediaFeedXML"
        label="Mediafeed XML"
        hideDetails
        outlined
        @input="handleChangeIsModified"
      />
    </v-flex>
  </v-layout>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    name: 'Form66MediaFeed',
    props: {
      editedItem: {
        type: Object,
        required: true
      },
      onChangeIsModified: {
        type: Function,
        required: true,
      },
      config: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      content: null,
    }),
    computed: {        
      ...mapState('app', ['locale']),
    },
    watch: {
      editedItem () {
        this.prepareContent()
      },
    },
    mounted () {
      this.prepareContent()
    },
    methods: {
      prepareContent () {
        this.content = this.editedItem
      },
      handleChangeIsModified () {
        this.onChangeIsModified(this.content) 
      },
    },
  }
</script>

